import React, { useEffect, useRef, useState } from "react";
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';

import swal from "sweetalert";
import swal2 from "sweetalert2";
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Menu,
    MenuItem, Avatar, ListItemText, ListItemIcon, Typography, CircularProgress
} from "@material-ui/core";

import { KeyboardArrowDown } from "@material-ui/icons";

import { stepsSolicitation } from "../../domain/constant/steps.solicitation.constant";
import { requestServices } from "../../domain/constant/request.services.constant";

import requestValidator from "../../domain/validators/request.validator";

import loginService from "../../domain/services/login.service";
import requestStatusService from "../../domain/services/solicitation/request.status.service";
import documentsService from "../../domain/services/solicitation/documents.service";
import requestServicesService from "../../domain/services/solicitation/request.services.service";
import requestReviewService from "../../domain/services/request/request.review.service";

import LoadingProgress from "../LoadingProgress";
import CustomerReturnSolicitation from "../solicitations/customer.return.solicitation.component";
import ChecklistRemember from "../solicitations/check-list/check.list.remember.component";
import RequestRatingForm from "../requests/rating/request.rating.form.component";
import AnalysisRatingForm from "../requests/rating/analysis.rating.form.component";
import InternalWorkingTime from "../solicitations/internal.working.time.component";
import LinkSettingsForm from "../solicitations/link.settings.form.component";
import PendingForm from "../requests/pending/pending.form.component";
import ChecklistConclude from "../solicitations/check-list/check.list.conclude.component";
import userConstant from "../../domain/constant/user.constant.js"

import RequestIaRatingDialog from "./rating/request.ia.rating.dialog.component.js"
import { useHistory } from "react-router-dom";

import MissingMainDocumentModal from "./documents/missing.main.document.modal.component";
import MissingRequiredDocumentsModal from "./documents/missing.required.documents.modal.component";
import { resolveConcludeError, CONCLUDE_ERROR } from "./conclude.error.resolver";
import { chooseSkipValidationParams } from "./skip.validation.confirmation";
import { inviteToFillNotionFields } from "./notion.fields.invite";
import useUploadsInFlight from '../../hooks/upload/useUploadsInFlight';
import { lockedStyle } from '../upload/UploadLock';

const INITIAL_MISSING_MAIN_DOC = { open: false, serviceName: null };
const INITIAL_REQUIRED_KINDS = { open: false, pendencies: [], attachedDocuments: [], pendingRetry: null };

function StatusForm({ request, onRefreshRequest, setAlert }) {
    const { inFlight } = useUploadsInFlight();

    const history = useHistory();

    const [availableSteps, setAvailableSteps] = useState([]);
    const [step, setStep] = useState({});
    const [openCorrection, setOpenCorrection] = useState(false);

    const [openRating, setOpenRating] = useState(false);
    const [openAnalysisRating, setOpenAnalysisRating] = useState({ show: false });
    const [openLinkSettings, setOpenLinkSettings] = useState(false);
    const [workingTime, setWorkingTime] = useState({ show: false, isReviewer: false, isAnalyst: false });
    const [openRememberDialog, setOpenRememberDialog] = useState(false);
    const [openCheckListConclude, setOpenCheckListConclude] = useState({ show: false, action: 'conclude' });
    const [missingMainDocModal, setMissingMainDocModal] = useState(INITIAL_MISSING_MAIN_DOC);
    const [requiredKindsModal, setRequiredKindsModal] = useState(INITIAL_REQUIRED_KINDS);

    const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
    const [newStep, setNewStep] = useState({});
    const [userSource, setUserSource] = useState({})

    const [anchorMenu, setAnchorMenu] = useState(null);
    const open = Boolean(anchorMenu);

    const { promiseInProgress } = usePromiseTracker();

    const stepRequest = requestStatusService.getStepByKeyAndUserSource(request.status);

    const prevStatusRef = useRef();

    useEffect(() => {

        setUserSource(JSON.parse(localStorage.getItem('@facilita-app/user')).source);

        if (request.status != prevStatusRef.current) {
            getAvailableSteps(request.id);
            setStepByStatus(request.status);
        }

        prevStatusRef.current = request.status;

    }, [request.status]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const autoConclude = urlParams.get('conclude');

        if (autoConclude === 'true') {
            const actionType = urlParams.get('actionType') || 'conclude';

            const url = new URL(window.location);
            url.searchParams.delete('conclude');
            url.searchParams.delete('actionType');
            window.history.replaceState(null, null, url.toString());

            if (actionType === 'sampling') {
                concludeBySamplingDirect({ stepName: stepsSolicitation.CONCLUDED, requestId: request.id });
            } else {
                changeStepDirect({ stepName: stepsSolicitation.CONCLUDED, requestId: request.id });
            }
        }
    }, [request.id]);

    const getAvailableSteps = async (requestId) => {

        if (!requestId) return;

        const { data } = await requestStatusService.getAvailableSteps(requestId);

        const steps = (data || []).map(item => {

            const stepValue = requestStatusService.getStepByKey(item.name);
            const disabledAction = (stepValue.disabledAction || {});

            return ({
                ...item,
                label: requestStatusService.getStepLabelBySource(item),
                icon: stepValue.icon,
                backgroundColor: stepValue.background,
                disabledAction: disabledAction[loginService.getUserAuthentication().source]
            });
        })

        setAvailableSteps(steps || []);
    }

    const setStepByStatus = (status) => {
        let item = requestStatusService.getStepByKey(status);
        setStep({ ...item, backgroundColor: item.background, label: item.value });
    }

    const onChangeFields = (field, value) => {
        step[field] = value;
        setStep({ ...step });
    }

    const handleOnfinish = () =>
        handleIaFeedback(newStep, true);

    const handleIaFeedback = (newStep, isFeedbackSave) => {

        if (!isFeedbackSave) {
            return false;
        }

        setOpenFeedbackModal(false)
        return handleSave(newStep)
    };

    const handleStepAction = (newStep) => {
        const needFaciliterFeedback = (newStep.name === stepsSolicitation.CONCLUDED || newStep.name === stepsSolicitation.SAMPLING) && request.generatedAutomaticServiceAt && !request.isInCorrection && userSource === userConstant.rolesKeys.FACILITER;

        if (!needFaciliterFeedback) {
            return handleSave(newStep)
        }

        setNewStep(newStep)
        setOpenFeedbackModal(true)
        return handleIaFeedback(newStep)
    }

    const handleSave = async (newStep) => {

        handleClose();

        const stepChangeConfirmation = getLeavingStepConfirmation(step.key) || getNewStepConfirmation(newStep.name);

        if (!stepChangeConfirmation)
            return handleChange(newStep);

        return stepChangeConfirmation
            .action()
            .then(isConfirmed => isConfirmed && handleChange(newStep));
    }

    const handleChange = async (newStep, skipValidationsParams) => {

        const actionByStep = getActionByStep(newStep, step);

        if (actionByStep) {
            actionByStep.action();
            return;
        }

        if (step.position > newStep.position) {
            setStep({ ...step, isConfirm: true, new: { ...newStep } });
            return;
        }

        await changeStep({ stepName: newStep.name, requestId: request.id, ...skipValidationsParams });
    }

    const getNewStepConfirmation = (step) => ({
        REVOKED: {
            action: () => (
                swal({
                    title: "Arquivar solicitação",
                    text: `Ao confirmar esta ação, a solicitação será descontinuada e o saldo ficará disponível para uso. Deseja continuar?`,
                    icon: "warning",
                    buttons: {
                        cancel: 'Cancelar',
                        confirm: { text: 'Confirmar', className: 'MuiButton-containedPrimary' }
                    }
                }).then(res => !!res)
            )
        },
    })[step];

    const getLeavingStepConfirmation = (step) => ({
        REVOKED: {
            action: () => (
                swal({
                    title: "Desarquivar solicitação",
                    text: "Ao confirmar esta ação, a solicitação será cobrada novamente e voltará para produção. Deseja continuar?",
                    icon: "warning",
                    buttons: {
                        cancel: 'Cancelar',
                        confirm: { text: 'Confirmar', className: 'MuiButton-containedPrimary' },
                    }
                }).then(res => !!res)
            )
        },
    })[step];

    const redirectToCorrection = () => history.push(`/solicitations/${request.mainId || request.id}/correction`);

    const redirectToReview = (actionType) => {
        const currentPath = window.location.pathname;
        history.push(`${currentPath}?returnTo=conclude&actionType=${actionType}#review`);
    };

    const getActionByStep = (newStep, step) => {
        return {
            LINK: {
                action: () => setOpenLinkSettings(true)
            },
            PENDING: {
                action: () => setStep({ ...step, isPending: true, new: { ...newStep } })
            },
            REVIEW: {
                action: () => setReview()
            },
            SAMPLING: {
                action: () => setConcluded('sampling')
            },
            CONCLUDED: {
                action: () => setConcluded('conclude')
            },
            CORRECTION: {
                action: () => redirectToCorrection(),
            },
            REVOKED: {
                action: () => handleRevoke(request)
            },
        }[newStep.name];
    }

    const handleRevoke = async (request) => {

        try {
            await requestStatusService.revokeRequest(request.mainId || request.id);

            setAlert("Salvo com sucesso", "success")

            onRefreshRequest()
        }
        catch (error) {
            warningAlert(error?.response?.data?.message)
        }

    }

    const setReview = () => {

        const concludeData = { stepName: stepsSolicitation.REVIEW, requestId: request.id };

        if (!loginService.isFaciliter() || requestValidator.isAnalysisModality(request) || requestValidator.isCalculationModality(request.modalityId))
            return checkToShowAnalysisReview(() => changeStep(concludeData));

        setOpenRememberDialog(true);
    }

    const concludeMethodByAction = {
        sampling: (props) => concludeBySampling(props),
        conclude: (props) => changeStep(props),
    }

    const checkForReviewChecklist = async () => {

        const reviewData = await requestReviewService.findByRequestId(request.id);

        return !!reviewData && reviewData.checklist?.length > 0
    };

    const setConcluded = async (actionType) => {

        const conclusionProps = { stepName: stepsSolicitation.CONCLUDED, requestId: request.id }
        const concludeAction = () => concludeMethodByAction[actionType](conclusionProps);

        const hasConclusionSteps = [requestServices.PETITION, requestServices.CALCULATION].includes(request.serviceKey);

        if (!hasConclusionSteps)
            return concludeAction();

        return setOpenCheckListConclude({ show: true, action: concludeAction, conclusionType: actionType });
    }

    const onSaveConcludeChecklist = async () => {

        if (!requestValidator.isPetitionService(request.serviceKey))
            return openCheckListConclude.action();

        if (request.status === stepsSolicitation.REVIEW && openCheckListConclude.conclusionType != 'sampling') {
            setWorkingTime({ show: true, isReviewer: true, isAnalyst: false, action: openCheckListConclude.action });
            return;
        }

        checkToShowAnalysisReview(openCheckListConclude.action)
    }

    const checkIfHasToReviewAnalysis = () =>
        requestValidator.isPetitionService(request.serviceKey)
        && request.analysisWasDevelopedByIa
        && ![stepsSolicitation.REVIEW].includes(request.status)
        && !request.additionalInformation?.numberOfCorrections;

    const checkToShowAnalysisReview = async (action) => {

        const hasToReviewAnalysis = checkIfHasToReviewAnalysis();

        if (!hasToReviewAnalysis)
            return action();

        setOpenAnalysisRating({ show: true, action });
    }

    const concludeBySamplingDirect = async (item) =>
        trackPromise(
            requestStatusService.concludeBySampling(item)
                .then(response => setStepByStatus(response?.data?.requestStatus || (item.keepScheduledDelivery ? request.status : item.stepName)))
                .then(() => getAvailableSteps(item.requestId))
                .then(onRefreshRequest)
                .then(() => !item.keepScheduledDelivery && requestServicesService.checkToRedirectService(item.stepName, request))
                .then(() => {
                    if (loginService.isFaciliter() && [stepsSolicitation.CONCLUDED, stepsSolicitation.SAMPLING].includes(item.stepName)) {
                        history.push(`/solicitations/${request.id}/concluded-service`);
                        return;
                    }
                })
                .catch((err) => handleChangeError(err, item, concludeBySamplingDirect))
        );

    const concludeBySampling = async (item) => {
        if (loginService.isFaciliter()) {
            try {
                const hasReviewChecklist = await checkForReviewChecklist();

                if (hasReviewChecklist) {
                    redirectToReview('sampling');
                    return;
                }
            } catch (error) {
            }
        }

        return concludeBySamplingDirect(item);
    };

    const changeStepDirect = async (item) =>
        trackPromise(
            requestStatusService
                .changeStep(item)
                .then(async response => { await checkNewAgendaRequests(response); return response; })
                .then(response => {
                    requestStatusService.checkFaciliterAccessLimit(item.stepName, request.faciliterReviewers);
                    setStepByStatus(response?.data?.requestStatus || (item.keepScheduledDelivery ? request.status : item.stepName));
                })
                .then(() => getAvailableSteps(item.requestId))
                .then(onRefreshRequest)
                .then(() => !item.keepScheduledDelivery && requestServicesService.checkToRedirectService(item.stepName, request))
                .then(() => {

                    if (loginService.isFaciliter() && item.stepName === stepsSolicitation.CONCLUDED) {
                        history.push(`/solicitations/${request.id}/concluded-service`);
                    }
                })
                .catch((err) => handleChangeError(err, item, changeStepDirect))
        );

    const changeStep = async (item) => {
        if (item.stepName === stepsSolicitation.CONCLUDED && (loginService.isFaciliter() || loginService.isInternal())) {
            try {
                const hasReviewChecklist = await checkForReviewChecklist();
                if (hasReviewChecklist) {
                    redirectToReview('conclude');
                    return;
                }
            } catch (error) {
            }
        }

        return changeStepDirect(item);
    };

    const refusalHandlers = {
        [CONCLUDE_ERROR.MISSING_MAIN_DOCUMENT]: (data) =>
            setMissingMainDocModal({ open: true, serviceName: data.serviceName || null }),

        [CONCLUDE_ERROR.MISSING_REVIEWER_FEEDBACK]: () => setOpenRating(true),

        [CONCLUDE_ERROR.MISSING_NOTION_FIELDS]: (data) =>
            inviteToFillNotionFields(data.message)
                .then(confirmed => confirmed && history.push(`/solicitations/${request.id}/notion`)),

        [CONCLUDE_ERROR.MISSING_REQUIRED_DOCUMENTS]: (data, selectedStep, callback) =>
            loadAttachedCandidates().then(attachedDocuments =>
                setRequiredKindsModal({
                    open: true,
                    pendencies: data.pendencies,
                    attachedDocuments,
                    pendingRetry: { selectedStep, callback },
                })),

        [CONCLUDE_ERROR.PLAIN_MESSAGE]: (data) => warningAlert(data?.message),

        [CONCLUDE_ERROR.SKIP_VALIDATION_OFFER]: (data, selectedStep, callback) =>
            chooseSkipValidationParams(data?.skipValidationInfo)
                .then(params => params && callback({ ...selectedStep, ...params }))
                .catch(err => setAlert((err?.response?.data?.message), 'error')),
    };

    const handleChangeError = (error, selectedStep, callback) => {

        const data = error?.response?.data;

        return refusalHandlers[resolveConcludeError(data)](data, selectedStep, callback);
    }

    const warningAlert = (message) => {
        swal2.fire({
            title: 'Atenção',
            text: message || 'Não foi possível atualizar a fase do serviço. Por favor contate o suporte',
            icon: 'warning',
            confirmButtonText: 'Entendi',
        });
    }

    const loadAttachedCandidates = async () => {
        try {
            const docs = await documentsService.find(request.id);
            return (docs || [])
                .filter(d => !d.deleted)
                .filter(d => !d.isServiceMainDocument || d.serviceId === request.serviceId)
                .map(d => ({ id: d.id, name: d.name, serviceId: d.serviceId }));
        } catch (err) {
            return [];
        }
    }

    const checkNewAgendaRequests = ({ data }) => {

        const newAgendaRequests = data?.newAgendaRequests || [];

        if (!newAgendaRequests.length)
            return;

        return swal2.fire({
            title: 'Novas vinculações na pauta',
            html: `
                <div style="text-align: left;">
                    <p>
                        O ID movido estava ativo na pauta, novos IDs foram vinculados para substituí-lo.
                    </p>
                    ${newAgendaRequests.map(req => `
                        <p>
                            Membro: ${req.responsibleName} <br>
                            Novo serviço vinculado: ID <b>${req.requestId}</b> - ${req.agendaName}
                        </p>
                    `)}
                </div>
            `,
            icon: 'success',
            confirmButtonText: 'Entendi',
        });
    }

    const finishReview = async () => {

        const action = workingTime.action;

        setWorkingTime({ show: false, isReviewer: false, isAnalyst: false });

        const numberOfCorrections = request.additionalInformation?.numberOfCorrections;

        if (!!numberOfCorrections)
            return action();

        return setOpenRating(true);
    }

    const getOptions = () => {

        let stepOptions = [...availableSteps];

        return stepOptions.map((item, i) => (
            !item.disabledAction &&
            <MenuItem
                key={i}
                onClick={() => { handleStepAction(item) }}
                disabled={promiseInProgress}
                disableRipple
                style={{ borderBottom: "1px solid #eee", margin: "5px" }}>
                <ListItemIcon style={{ minWidth: "48px" }}>
                    <Avatar style={{ backgroundColor: item.backgroundColor, width: "30px", height: "30px" }}>
                        {item.icon}
                    </Avatar>
                </ListItemIcon>
                <ListItemText
                    primary={
                        <Typography
                            style={{
                                whiteSpace: "nowrap", width: "18em", overflow: "hidden", textOverflow: "ellipsis",
                                font: "500 14px/24px Google Sans, -apple-system, BlinkMacSystemFont, sans-serif"
                            }}
                        >
                            {item.label}
                        </Typography>
                    }
                />
            </MenuItem>
        ))
    }

    const returnStepToCorrection = async () =>
        changeStep({ stepName: stepsSolicitation.CORRECTION, requestId: request.id })
            .then(() =>
                (request.members || []).some(i => i.isAssureIncome)
                && onRefreshRequest()
            );

    const cancelCorrection = () =>
        setStep({ ...step, isCorrection: false });

    const sendToPending = async () =>
        changeStep({ stepName: stepsSolicitation.PENDING, requestId: request.id });

    const cancelPending = () =>
        setStep({ ...step, isPending: false });

    const handleClose = () =>
        setAnchorMenu(null);

    const confirmDialog = () => {

        const close = () =>
            setStep({ ...step, isConfirm: false });

        const newValue = (step) =>
            ({ stepName: step.new.name, requestId: request.id, description: step.description })

        return <Dialog open={(step.isConfirm || false)} onClose={close}>

            <DialogTitle>Informe o motivo de mover para {(step.new || {}).label}</DialogTitle>

            <DialogContent>
                {promiseInProgress && <LoadingProgress />}

                {!promiseInProgress &&
                    <TextField id="description" label="Motivo" fullWidth
                        multiline={true} autoFocus margin="dense"
                        onChange={(e) => { onChangeFields('description', e.target.value); }} />
                }
            </DialogContent>

            <DialogActions>

                <Button onClick={close} color="primary" disabled={promiseInProgress}>
                    Cancelar
                </Button>

                <Button
                    onClick={() => changeStep(newValue(step))}
                    color="primary" disabled={promiseInProgress || inFlight} title={inFlight ? 'aguarde o envio terminar' : undefined}
                >
                    Confirmar
                </Button>

            </DialogActions>
        </Dialog>
    }

    return (
        <React.Fragment>
            <div>

                <Button
                    aria-haspopup="true" fullWidth aria-expanded={open}
                    variant="contained" disableElevation
                    disabled={promiseInProgress || inFlight} title={inFlight ? 'aguarde o envio terminar' : undefined}
                    onClick={(event) => setAnchorMenu(event.currentTarget)}
                    endIcon={!!availableSteps.length && <KeyboardArrowDown />}
                    style={{
                        fontWeight: '600', color: 'white',
                        backgroundColor: stepRequest.background,
                        ...lockedStyle(inFlight)
                    }}
                >

                    {stepRequest.value}

                    {promiseInProgress && (
                        <CircularProgress style={{
                            color: "aliceblue", width: 14,
                            height: 14, marginLeft: 8
                        }} />
                    )}

                </Button>

                {!!availableSteps.length &&
                    <Menu
                        getContentAnchorEl={null}
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        transformOrigin={{ vertical: "top", horizontal: "left" }}
                        anchorEl={anchorMenu} open={open} onClose={handleClose}
                    >
                        {getOptions()}
                    </Menu>
                }

            </div>

            {step.isCorrection &&
                <CustomerReturnSolicitation
                    request={request}
                    mainRequestId={request?.mainId || request?.id}
                    open={openCorrection}
                    setOpen={setOpenCorrection}
                    returnStep={returnStepToCorrection}
                    cancelCorrection={cancelCorrection}
                    isCreating
                    setAlert={setAlert}
                />
            }

            {(step.isPending || false) &&
                <PendingForm status={request.status} requestId={request.id}
                    additionalInformation={request.additionalInformation}
                    onSave={sendToPending} cancelPending={cancelPending} />
            }

            {confirmDialog()}

            {workingTime.show &&
                <InternalWorkingTime
                    isReviewer={workingTime.isReviewer}
                    isAnalyst={workingTime.isAnalyst}
                    userId={loginService.getUserAuthentication().id}
                    requestId={request.id}
                    onSave={finishReview}
                    onCancel={() => setWorkingTime({ show: false, isReviewer: false, isAnalyst: false })}

                />
            }

            {openRating &&
                <RequestRatingForm
                    requestId={request.id}
                    onSave={changeStep}
                    onRefreshRequest={onRefreshRequest}
                    isModalOpen={openRating}
                    closeModal={() => setOpenRating(false)}
                    isInternal={loginService.isInternal()}
                    isReviewerConclusion={request.status === stepsSolicitation.REVIEW}
                    setAlertStatus={setAlert}
                />
            }

            {openAnalysisRating.show &&
                <AnalysisRatingForm
                    request={request}
                    onSave={openAnalysisRating.action}
                    onRefreshRequest={onRefreshRequest}
                    isModalOpen={openAnalysisRating.show}
                    closeModal={() => setOpenAnalysisRating({ show: false })}
                    setAlertStatus={setAlert}
                    showReviewForAllSituations={openAnalysisRating.show}
                />
            }

            {openLinkSettings &&
                <LinkSettingsForm
                    request={request}
                    onSave={changeStep}
                    onCancel={() => setOpenLinkSettings(false)}
                    onRefreshRequest={onRefreshRequest}
                    setAlert={setAlert}
                />
            }

            {openRememberDialog &&
                <ChecklistRemember
                    request={request}
                    onSave={(data) => checkToShowAnalysisReview(() => changeStep(data))}
                    onRefreshRequest={onRefreshRequest}
                    onCloseDialog={() => setOpenRememberDialog(false)}
                />
            }

            {openCheckListConclude.show &&
                <ChecklistConclude
                    request={request}
                    onSave={onSaveConcludeChecklist}
                    onCloseDialog={() => setOpenCheckListConclude({ show: false })}
                />
            }

            <RequestIaRatingDialog
                request={request}
                isOpen={openFeedbackModal}
                onClose={() => setOpenFeedbackModal(false)}
                onFinish={handleOnfinish}
                setAlert={setAlert}
            />

            <MissingMainDocumentModal
                open={missingMainDocModal.open}
                serviceName={missingMainDocModal.serviceName}
                onClose={() => setMissingMainDocModal(INITIAL_MISSING_MAIN_DOC)}
                onAttach={() => {
                    setMissingMainDocModal(INITIAL_MISSING_MAIN_DOC);
                    history.push(`/solicitations/${request.id}#documents`);
                }}
            />

            <MissingRequiredDocumentsModal
                open={requiredKindsModal.open}
                pendencies={requiredKindsModal.pendencies}
                attachedDocuments={requiredKindsModal.attachedDocuments}
                onClose={() => setRequiredKindsModal(INITIAL_REQUIRED_KINDS)}
                onSelectExisting={async (documentKind, documentId) => {
                    try {
                        await documentsService.update({
                            id: documentId,
                            requestId: request.id,
                            isServiceMainDocument: true,
                            serviceId: request.serviceId,
                        });
                        setRequiredKindsModal(prev => ({
                            ...prev,
                            pendencies: prev.pendencies.filter(p => p.documentKind !== documentKind),
                        }));
                        return { success: true };
                    } catch (err) {
                        return { success: false };
                    }
                }}
                onAttach={async (documentKind, file) => {
                    try {
                        const stagings = await documentsService.saveAllStaging(request.id, [file]);
                        const stagingIds = (stagings || []).map(s => s.id || s.stagingId).filter(Boolean);
                        if (stagingIds.length === 0) {
                            return { success: false, message: 'Nao foi possivel subir o arquivo. Tente novamente.' };
                        }
                        const classified = await documentsService.classifyStaging(request.id, stagingIds);
                        const items = (classified && classified.items) || [];
                        if (items.length === 0) {
                            return { success: false, message: 'Falha ao classificar o arquivo. Tente novamente.' };
                        }
                        const item = items[0];
                        const detectedRole = (item.classification && item.classification.role) === 'main' ? 'main' : 'complementary';
                        try {
                            await documentsService.finalizeStaging(request.id, [{
                                stagingId: item.stagingId || item.id,
                                role: detectedRole,
                                documentKind,
                            }]);
                        } catch (finalizeErr) {
                            const backendMessage = finalizeErr?.response?.data?.message
                                || finalizeErr?.message
                                || 'Backend recusou o documento. Verifique o conteudo e tente novamente.';
                            return { success: false, message: backendMessage };
                        }
                        setRequiredKindsModal(prev => ({
                            ...prev,
                            pendencies: prev.pendencies.filter(p => p.documentKind !== documentKind),
                        }));
                        return { success: true };
                    } catch {
                        return { success: false, message: 'Erro inesperado ao anexar. Tente novamente.' };
                    }
                }}
                onItemResolved={(documentKind) => {
                    setRequiredKindsModal(prev => {
                        const remaining = prev.pendencies.filter(p => p.documentKind !== documentKind);
                        if (remaining.length === 0) {
                            if (prev.pendingRetry && typeof prev.pendingRetry.callback === 'function') {
                                prev.pendingRetry.callback(prev.pendingRetry.selectedStep);
                            } else {
                                onRefreshRequest && onRefreshRequest();
                            }
                            return INITIAL_REQUIRED_KINDS;
                        }
                        return { ...prev, pendencies: remaining };
                    });
                }}
            />

        </React.Fragment>
    );
}

export default StatusForm;
